import { Box } from '@mui/material'
import classes from './global-hover-sidebar.module.scss'

interface EdgeTriggerProps {
  position: 'left' | 'right'
  onMouseEnter: () => void
  isHidden?: boolean
}

const EdgeTrigger = ({
  position,
  onMouseEnter,
  isHidden = false,
}: EdgeTriggerProps) => {
  if (isHidden) return null

  return (
    <Box
      className={`${classes['edge-trigger']} ${classes[`edge-trigger--${position}`]}`}
      onMouseEnter={onMouseEnter}
      role="button"
      tabIndex={0}
      aria-label={`Open ${position} sidebar`}
    />
  )
}

export default EdgeTrigger
